























































































































import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import {QueryStandingBookDetail,QuerySupplier,CreateStockCheck,
       QueryConsumableCheck,QueryConsumableCheckDetailById,
       QueryConsumableBatchNum,EditStockCheckCheck,
       EditStockCheckCharge,DeleteStockCheck
} from '../../../api/consumablesStock'
import {GetConsumables,GetUtcodeList} from '../../../api/specialDictionary'

import {GetAutCodeList} from '../../../api/basicDictionary'
import Util from '../../../lib/util'
import u from 'underscore'

//单据打印组件
import print from '../../../components/print/stockBills.vue'

@Component({
    components:{print}
})
export default class Check extends AbpBase {
	printShow:Boolean = false;
    printData = {
        list:[],
        title:[
            '单据编码',
            '耗材名称',
            '生产厂家',
            '原数量',
            '现数量',
            '盘亏/盘盈数量',
            '单位',
            '进价',
            '进价盘点',
            '零价',
            '零价盘点',
            '批号',
            '盘点人',
            '盘点日期',
        ]
    }

    list = []//table数据源
	tabList:any = []//选择table数据源
	table = {
        loading:false,
        tabLoading:false,
    }
       //远程搜索加载
    remoteloading:Boolean = true;
    //点击选择or不选中
    flag:Boolean = true;

    //按钮装态
    deleteBillsShow:Boolean = false
    ztShow:Boolean = false
    checkShow:Boolean = true
    saveShow:Boolean = true

    //当前选择行状态 （暂存可新增，核对不可）
    rowStatus:Boolean = false;
    //核对loding
    checkLoding:Boolean = false;
    //暂存loding
    tsLoding:Boolean = false;
    //记账loding
    saveLoding:Boolean = false;
    //删除loding
    deleteLoding:Boolean = false;

    receiptNo:Number = Date.now();

    //数值累计判断
    reducePrice:Boolean = false;
    //当前选择行
    rowActive:any = {}
    model = {
        consumableId:null,
        quantity:null,
        nowQuantity:null,
        unit:null,
        batchNo:null,
        purchasePrice:null,
        zeroPrice:null,
    }

    created() {
        // this.getDrugList();
        // this.getMeteringList();
        this.getTabList()
    }
    //选择框数据
    unitOptions=[]
    conList=[]
    consumableOptions=[]
    bathNoOptions=[]

    //获取tab 数据
    async getTabList(){
		this.table.tabLoading = true
		let payload = {
			pageSize:100,
			Page:1
		}
		let response = await QueryConsumableCheck(payload)
		this.tabList = response.data.items
        this.table.tabLoading = false
        //默认选择第一条
        if(this.tabList.length>0) {
            this.tabList[0]._highlight = true;
            this.rowActive = this.tabList[0];
            this.deleteBillsShow = false
            this.getStatus(this.tabList[0].stockCheckStatus)
            this.getTalDetail(this.tabList[0].id)
            //单据号
            this.receiptNo = Number(this.tabList[0].receiptNo)
            
        }else{
            this.rowActive = {}
            this.ztShow = false
            this.checkShow = true
            this.saveShow = true
            this.rowStatus = false
            this.deleteBillsShow = true
        }
    }
    getStatus(type){
        //按钮status
        if(type == 1){
            this.ztShow = false
            this.checkShow = false
            this.saveShow = true
            this.deleteBillsShow = false
            this.rowStatus = false
        }else{
            this.ztShow = true
            this.checkShow = true
            this.saveShow = false
            this.deleteBillsShow = false
            this.rowStatus = true
        }
        
    }
    //获取详情数据
    async getTalDetail(id){
         let data = {
            stockCheckId:id,
            pageSize:100,
            page:1
        }
        let res  = await QueryConsumableCheckDetailById(data)
        this.list = res.data.consumableCheckDetailResult.items
        this.reducePrice = true;
        this.list.push({
            zj:true,
            receiptNo:'总价',
            batchCkPurchasePrice:res.data.sumCkPurchasePrice,
            zeroCkPrice:res.data.sumCkZeroPrice,
        })
    }

    //选择耗材信息
    consumableActiveinfo:any = {};
    //表格高度
    get tableHeight(){
        return window.innerHeight-580
    }
    //登陆人
    get staffName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
    //耗材
	async remoteMethodCon(query){
        let str = (this.$refs['setSelect'] as any).$data.query;
        if (str) {
        //赋值为空
            (this.$refs['setSelect'] as any).query = ''
        }
        this.consumableOptions = [];
		if (query !== '') {
			this.remoteloading = true;
            let data = {
                consumableName:query,
                optType:true,
            }
            let res = await QueryConsumableBatchNum(data)
            this.conList = res.data
            setTimeout(() => {
                this.remoteloading = false;
                const list = res.data.map(item => {
                    return {
                        consumableId: item.consumableId,
                        consumableName: item.consumableName
                    };
                });
                this.consumableOptions = list
            }, 200);
           
        } else {
            this.consumableOptions = [];
        }
    }
   //单位
    async getMeteringList(){
        let res = await this.$store.dispatch({
            type:'dictionaries/GetMeteringList',
        })
        this.unitOptions = res.data.items
    }
    //耗材信息带出
    conChange(){
        if(this.model.consumableId){
            this.bathNoOptions = []
            this.conList.forEach(item=>{
                if(item.consumableId==this.model.consumableId){
                    this.consumableActiveinfo = item;
                     //单位选项
                    this.unitOptions = []
                    this.unitOptions.push({
                        id:Number(item.basicUnit),
                        meterName:item.basicUnitName
                    })
                    this.model.zeroPrice = item.sellPrice
                    
                    this.model.unit = item.batchNumberArr[0].basicUnitId
                    this.model.quantity = item.batchNumberArr[0].quantity
                    this.model.purchasePrice = item.batchNumberArr[0].buyPrice
                    this.model.batchNo = item.batchNumberArr[0].batchNo

                    this.bathNoOptions = item.batchNumberArr
                }
            })
       }
    }
    //批号选择带出
    batchNoChange(){
        if(this.model.batchNo){
            this.bathNoOptions.forEach(item=>{
                if(item.batchNo==this.model.batchNo){
                    this.model.unit = item.basicUnitId
                    this.model.quantity = item.quantity
                    this.model.purchasePrice = item.buyPrice
                    this.model.batchNo = item.batchNo

                }
            })
       }
    }
    //数据导出
    exportData(){
        (this.$refs.table as any).exportCsv({
            filename: 'The original data'
        })
    }
     //清除高亮项
    clearCurrentRow(callback){
        (this.$refs.tabTable as any).clearCurrentRow()
        //重新生成单据号
        this.receiptNo = Date.now()
        this.rowActive = {};
        this.list = []
        this.ztShow = false
        this.checkShow = true
        this.saveShow = true
        this.deleteBillsShow = true
        this.rowStatus = false
        callback()
    }
    //点击清除高亮
    firstTabChage:Boolean = true //(默认加载第一条。取消选择不会触发tabChange事件。记录没触发tabChange之前的状态)
    clecarActive(row){
        let indexs;
        this.tabList.forEach((item,index) => {
            if(item.id == row.id){
                indexs = index;
            }
        });
        if(this.rowActive.id == row.id && this.firstTabChage){
            this.clearCurrentRow(function(){})
        }
        if(this.flag){
            // this.tabList[indexs]._highlight = true;
            this.flag = false
            // this.deleteBillsShow = false;
        }else{
            this.clearCurrentRow(function(){})
            this.flag = true
        }
    }

    //表格添加
    push(){
         let that = this;
        (this.$refs.ruleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                //清空表格尾部
                if(this.reducePrice){
                    this.list.pop()
                }
                this.list.push({
                   receiptNo:this.receiptNo,
                   consumableName:this.consumableActiveinfo.consumableName,
                   consumableId:this.consumableActiveinfo.consumableId,
                   quantity:this.model.quantity,
                   nowQuantity:this.model.nowQuantity,
                   quantityDiff:this.model.quantity-this.model.nowQuantity,
                   unit:this.model.unit,
                   unitName: u.find(that.unitOptions, function(value, key, list){return list[key].id == that.model.unit}).meterName,
                   batchNo:this.model.batchNo,
                   checkQuantity:this.model.nowQuantity-this.model.quantity,
                   zeroPrice:this.model.zeroPrice,
                   purchasePrice:this.model.purchasePrice,
                   batchCkPurchasePrice:this.model.purchasePrice*(this.model.nowQuantity-this.model.quantity),
                   zeroCkPrice:this.model.zeroPrice*(this.model.nowQuantity-this.model.quantity),
                   manufacturer:this.consumableActiveinfo.manufacturer,
                   staffName:this.staffName,
                   now:Util.dateConversion(new Date())
                })
                let values1 = this.list.map(item => Number(item.batchCkPurchasePrice));
                let values2 = this.list.map(item => Number(item.zeroCkPrice));
                let purchasePriceCount = u.reduce(values1, function(memo, num){ return memo + num; }, 0);
                let zeroPriceCount = u.reduce(values2, function(memo, num){ return memo + num; }, 0);
                //合计计算
                
                this.list.push({
                    zj:true,
                    receiptNo:'总价',
                    batchCkPurchasePrice:purchasePriceCount,
                    zeroCkPrice:zeroPriceCount,
                })
                 this.reducePrice = true
                this.clear();

                //清空选择项
                (this.$refs['setSelect'] as any).query = ''
                this.consumableOptions = [];
            }
        })
    }
     //暂存
    Ts(){
        if(this.list.length<1){
            this.$Message.info('请选择耗材');
            return false
        }
         //去掉合计
        this.list.pop()
        let data = {
            receiptNo:this.receiptNo,
            stockCheckId:this.rowActive.id || 0,
            consumableCheckInputDetailDto:this.list,
        }
        this.createStockCheck(data)
    }
    async createStockCheck(data){
        let res = await CreateStockCheck(data)
        if(res.code==2000){
            //  
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
        }else{
            //  
        }
        this.tsLoding = false;
    }

    //核对
    async check(){
        let data = {
            stockCheckDel:[{stockCheckId:this.rowActive.id}]
        }
        this.checkLoding = true;

        let res = await EditStockCheckCheck(data)
        if(res.s==2000){
            //  
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()

        }else{
            //   
        }
        this.checkLoding = false;
    }
    //打印完成回调
    printBack(){
        this.printShow = false;
    }
    //记账
    async save(){
        let data = {
            stockCheckDel:[{stockCheckId:this.rowActive.id}]
        }
        let res = await EditStockCheckCharge(data)
        if(res.code==2000){

            this.printData.list = []
            this.list.forEach((item,index)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.consumableName,
                    item.manufacturer,
                    item.quantity,
                    item.nowQuantity,
                    item.checkQuantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchCkPurchasePrice,
                    item.zeroPrice,
                    item.zeroCkPrice,
                    item.batchNo,
                    item.staffName,
                    index == this.list.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true


            //  
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            this.saveLoding = false;
            // document.getElementById('pr').click()
        }else{
            //  
        }
        this.saveLoding = true;
    }
    //删除单据
    async deleteBills(){
        this.$Modal.confirm({
			title: '确认删除',
			content: '',
			onOk: () => {
                this.deleteLoding = true;
				let data = {
                    stockCheckDel:[{stockCheckId:this.rowActive.id}]
                }
				this.deleteStockCheck(data)
			},
			onCancel: () => {
				
			}
		})
       
        
    }
    async deleteStockCheck(data){
        let res = await DeleteStockCheck(data)
        if(res.code==2000){
            //  
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            this.deleteLoding = false;
        }else{
            //  
            this.deleteLoding = false;
        }
    }
    clear(){
		(this.$refs.ruleForm as any).resetFields();
    }
    
    delete(index:number){
        this.list.splice(index, 1);
        if(this.list.length==1){
            this.list.splice(0, 1);
        }
    }
     //tab选择
    tabChange(currentRow:any,oldCurrentRow:any){
        this.firstTabChage = false;

        if(currentRow){
            this.rowActive = currentRow
            //带出单据号
            this.receiptNo = Number(currentRow.receiptNo)
            this.getStatus(currentRow.stockCheckStatus)
            this.getTalDetail(currentRow.id)
            if(currentRow != oldCurrentRow){
                this.flag = true
            }
        }
    }
	columns = [{
		title: '单据编码',
        key: 'receiptNo',
        width:160
	},{
		title: "耗材名称",
		key: 'consumableName',
        width:130
	},{
		title: "生产厂家",
		key: 'manufacturer',
        width:130
	},{
		title: "原数量",
		key: 'quantity',
        width:130
	},{
		title: "现数量",
		key: 'nowQuantity',
        width:130
	},{
		title: "盘亏/盘盈数量",
        key: 'checkQuantity',
        width:120
	},{
		title: "单位",
		key: 'unitName',
        width:130
	},{
		title: "进价",
		key: 'purchasePrice',
        width:130
	},{
		title: "进价盘点",
		key: 'batchCkPurchasePrice',
        width:130
	},{
		title: "零价",
		key: 'zeroPrice',
        width:130
	},{
		title: "零价盘点",
		key: 'zeroCkPrice',
        width:130
	},{
		title: "批号",
		key: 'batchNo',
        width:130
	},{
		title: "盘点人",
		key: 'staffName',
        width:130
	},{
		title: "盘点日期",
		key: 'now',
        width:130,
         render: (h: any, params: any) => {
           if(params.row.now){
               return h('span',Util.formatTime(params.row.now))
           }else{
               return h('span',Util.formatTime(params.row.creationTime))
           }
        }
	},{title: this.L('Actions'),
        key: 'Actions',
        fixed: "right",
        width:80,
		render: (h: any, params: any) => {
			if(!params.row.zj){
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                                this.delete(params.add)
                            }
                        }
                    }, this.L('Delete'))
                ])
            }
		}
   
    }]

      tabColumns=[{
		title: '单据编码',
        key: 'receiptNo',
	},{
		title: "盘点日期",
        key: 'stockCheckDate',

	},{
		title: "操作员",
        key: 'staffName',
	},{
		title: "状态",
        key: 'stockCheckStatus',
        render:(h: any, params: any) => {
            return h('span',params.row.stockCheckStatus == 1?"暂存":"核对")
        }           
    }]
    rules={
        consumableId:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        unit:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        batchNo:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
        quantity:[{required: true,message:this.L('FieldIsRequired'),type:'number', trigger: 'blur'}],
        nowQuantity:[{required: true,message:this.L('FieldIsRequired'),type:'number', trigger: 'blur'}],
        purchasePrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        zeroPrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        nowZeroPrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],

    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/consumablesStock/check/index.vue